import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Map extends PureComponent {
    static propTypes = {
        data: PropTypes.array,
        code: PropTypes.string,
    };

    echarts = null;
    map = null;
    extraMap = null;

    nameMap = {};

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入世界地图
        await import('echarts/map/js/world');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        const { code } = this.props;

        this.map = this.echarts.init(document.getElementById('world'));
        this.mapRender();

        if (code === 'Japan') {
            this.extraMap = this.echarts.init(document.getElementById('extra_map'));

            this.nameMap = await import(`./name/${code}`);

            this.nameMap = this.nameMap.default;

            let map = '';
            let name = '';
            let mapType = '';
            let extra = {};

            map = await import('./json/Okinawa');
            name = '冲绳';
            this.echarts.registerMap('Okinawa', map);
            mapType = 'Okinawa';
            extra = {
                layoutCenter: ['30%', '90%'],
                layoutSize: '500%',
            };

            const cityArr = map.features.map(item => this.nameMap[item.properties.name] || '');

            const mapData = cityArr.map(item => this.getAreaData(item));

            console.log(mapData);

            const worldSeries = [
                {
                    name,
                    type: 'map',
                    mapType,
                    extra,
                    itemStyle: {
                        normal: {
                            borderColor: '#E2B2B2', // 边框颜色
                            borderWidth: 1, // 边框线宽
                        },
                    },
                    label: {
                        show: false,
                    },
                    data: mapData,
                    nameMap: this.nameMap,
                },
            ];

            const option = {
                tooltip: {
                    trigger: 'item',
                    showDelay: 0,
                    enterable: true,
                    transitionDuration: 0.2,
                    padding: 7,
                    borderWidth: 1,
                    extraCssText: 'background:rgba(0,0,0,0.6);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                    textStyle: {
                        color: '#FFFFFF',
                        fontFamily: 'PingFang-SC-Medium,PingFang-SC;',
                        fontSize: 12,
                        padding: 5,
                    },
                    formatter: params => {
                        if (params.data) {
                            let result = `<div>${params.name}</div>`;

                            params.data.num.forEach((item, index) => {
                                let color = '';
                                let text = '';

                                if (index === 0) {
                                    color = '#e10000';
                                    text = '确诊';
                                } else if (index === 1) {
                                    color = '#28B7A3';
                                    text = '治愈';
                                } else if (index === 2) {
                                    color = '#8C8C8C';
                                    text = '死亡';
                                }

                                result += `<div style="margin-top: 1px"><span style="display:inline-block;margin: 0 5px 3px 0;border-radius:50%;width:5px;height:5px;font-family: PingFangSC-Regular, PingFang SC;background-color:${color}"></span>${text}: ${item ||
                                    0}</div>`;
                            });

                            return result;
                        }

                        return '';
                    },
                },
                series: worldSeries,
            };

            this.extraMap.setOption(option);
        }
    }

    mapRender = async () => {
        const { code } = this.props;

        this.nameMap = await import(`./name/${code}`);

        this.nameMap = this.nameMap.default;

        let countryMap = await import(`./json/${code}`);

        countryMap = countryMap.default;

        if (code === 'USA') {
            this.echarts.registerMap('worldCity', countryMap, {
                Alaska: {
                    left: -131,
                    top: 27,
                    width: 15,
                },
                Hawaii: {
                    left: -110,
                    top: 24,
                    width: 7,
                },
            });
        } else {
            this.echarts.registerMap('worldCity', countryMap);
        }

        console.log(countryMap.features.map(item => item.properties.name));

        const cityArr = countryMap.features.map(item => this.nameMap[item.properties.name] || '');

        console.log(cityArr);

        const mapData = cityArr.map(item => this.getAreaData(item));

        let extra = {};

        if (code === 'Japan') {
            extra = {
                layoutCenter: ['65%', '70%'],
                layoutSize: '150%',
            };
        } else if (code === 'Korea') {
            extra = {
                top: 20,
                left: 0,
                right: 0,
                layoutCenter: ['50%', '50%'],
                layoutSize: '100%',
            };
        } else if (code === 'Italy') {
            extra = {
                top: 20,
                left: 0,
                right: 0,
                layoutCenter: ['50%', '50%'],
                layoutSize: '100%',
            };
        } else if (code === 'USA') {
            extra = {
                top: 20,
                left: 0,
                right: 0,
                layoutCenter: ['50%', '40%'],
                layoutSize: '120%',
            };
        }

        const worldSeries = [
            {
                name: '世界',
                type: 'map',
                mapType: 'worldCity',
                ...extra,
                itemStyle: {
                    normal: {
                        borderColor: '#E2B2B2', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap: this.nameMap,
            },
        ];

        const option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                enterable: true,
                transitionDuration: 0.2,
                padding: 7,
                borderWidth: 1,
                extraCssText: 'background:rgba(0,0,0,0.6);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                textStyle: {
                    color: '#FFFFFF',
                    fontFamily: 'PingFang-SC-Medium,PingFang-SC;',
                    fontSize: 12,
                    padding: 5,
                },
                formatter: params => {
                    if (params.data) {
                        let result = `<div>${params.name}</div>`;

                        params.data.num.forEach((item, index) => {
                            let color = '';
                            let text = '';

                            if (index === 0) {
                                color = '#e10000';
                                text = '确诊';
                            } else if (index === 1) {
                                color = '#28B7A3';
                                text = '治愈';
                            } else if (index === 2) {
                                color = '#8C8C8C';
                                text = '死亡';
                            }

                            result += `<div style="margin-top: 1px"><span style="display:inline-block;margin: 0 5px 3px 0;border-radius:50%;width:5px;height:5px;font-family: PingFangSC-Regular, PingFang SC;background-color:${color}"></span>${text}: ${item ||
                                0}</div>`;
                        });

                        return result;
                    }

                    return '';
                },
            },
            series: worldSeries,
        };

        this.map.setOption(option);
    };

    getAreaData = name => {
        const { data } = this.props;

        let areaObj = {
            name,
            itemStyle: {
                normal: {
                    areaColor: this.getColor(0),
                },
            },
            num: [0, 0, 0],
        };

        data.every(item => {
            if (name.indexOf(item.name3) === 0) {
                const quezhen = item.quezhen || 0;
                const zhiyu = item.zhiyu || 0;
                const siwang = item.siwang || 0;

                areaObj = {
                    ...areaObj,
                    name,
                    itemStyle: {
                        normal: {
                            areaColor: this.getColor(quezhen),
                        },
                    },
                    num: [quezhen, zhiyu, siwang],
                };

                return false;
            }

            return true;
        });

        return areaObj;
    };

    getColor = num => {
        let color = '#F2DADB';

        if (num > 99999) {
            color = '#420C0C';
        } else if (num > 9999) {
            color = '#6C0000';
        } else if (num > 999) {
            color = '#9E0707';
        } else if (num > 99) {
            color = '#BF5A53';
        } else if (num > 9) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    render() {
        const { code } = this.props;

        return (
            <div className={styles.box}>
                <div id="world" className={styles.map} />
                <span className={styles.tip} />
                {code === 'Japan' && <div id="extra_map" className={styles.extra_map} />}
            </div>
        );
    }
}

export default errorBoundary(Map);
